<template>
  <div class="el-table-container templateBox">
    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
             @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="90px">
      <el-form-item label="关键字：" prop="keyword">
        <el-input v-model.trim="searchForm.keyword" style="width: 250px" maxlength="20"
                  placeholder="请输入关键字(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
      <el-form-item class="f_r">
        <el-button v-if="hasPermission('academic:academic:semanticLibrary:export')" type="primary"
                   @click="exportData()"
                   size="small">导出
        </el-button>
      </el-form-item>
    </el-form>
    <div class="flex_b_c contentHeigh">
      <div :class="['dataBox', detailData ? 'dataBox1' : 'dataBox2']">
        <el-table
            :data="dataList"
            v-loading="loading"
            default-expand-all
            @select="selectFun"
            @select-all="selectAllFun"
            @selection-change="selectionChangeHandle"
            :row-class-name="getRowClassName"
            :header-row-class-name="getHeaderRowClassName"
            size="small" height="100%" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            class="table" ref="multipleTable" row-key='id' border>
          <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column prop="semanticName" label="名称" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span style="cursor: pointer" @click="seeDetail(row)">{{ row.semanticName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="semanticDescription" label="描述" show-overflow-tooltip></el-table-column>
          <el-table-column
              fixed="right" min-width="100px"
              label="操作">
            <template slot-scope="scope">
              <el-button v-if="hasPermission('academic:academic:semanticLibrary:addData')" type="text" size="small"
                         @click="addData(1,scope.row)">新增同级
              </el-button>
              <el-popover
                  placement="top-start"
                  trigger="hover" :disabled="!scope.row.disabledBotm"
                  :content="`最多支持${levelData}级节点`">
                <el-button v-if="hasPermission('academic:academic:semanticLibrary:addSon')" type="text" size="small"
                           :disabled="scope.row.disabledBotm" slot="reference"
                           @click="addData(2,scope.row)">新增子级
                </el-button>
              </el-popover>
              <el-button v-if="hasPermission('academic:academic:semanticLibrary:edit')" type="text" size="small"
                         @click="addData('edit',scope.row)">修改
              </el-button>
              <el-button v-if="hasPermission('academic:academic:semanticLibrary:deleteColumn')" type="text" size="small"
                         @click="deleteColumn(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dataDetail" v-if="detailData">
        <div class="flex_b_c b_b dataDetail-tir">
          <div class="title">{{ detailData.semanticName }}</div>
          <div class="closeD" @click="detailData = null">关闭</div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first"></el-tab-pane>
          <el-tab-pane label="资源数值列表" name="second"></el-tab-pane>
        </el-tabs>
        <div class="text_right" style="margin-bottom: 10px" v-show="activeName == 'first'">
          <el-button size="small" v-if="hasPermission('academic:academic:semanticLibrary:deleteColumn')"
                     @click="deleteColumn(detailData)">删除
          </el-button>
          <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
        <el-form v-show="activeName == 'first'" size="small" ref="detailForm" :model="detailForm" :rules="rules"
                 label-width="110px">
          <el-form-item label="名称：" prop="semanticName">
            <el-input v-model.trim="detailForm.semanticName" maxlength="20"
                      placeholder="请输入名称(限20字)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="描述：" prop="semanticDescription">
            <el-input
                type="textarea"
                :rows="5" maxlength="500" resize="none"
                placeholder="请输入语义库数据描述信息(限500字)"
                v-model.trim="detailForm.semanticDescription">
            </el-input>
          </el-form-item>
        </el-form>
        <div v-if="activeName == 'second'">
          <div class="flex_b_c" style="margin-bottom: 10px">
            <el-button size="small" type="primary" @click="addFigure()">新增</el-button>
            <div></div>
            <el-input v-model.trim="valueSearch.keyword" maxlength="20" size="small" style="width: 200px"
                      placeholder="请输入数值搜索(限20字)" suffix-icon="el-icon-search" @input="getValueList(1)"
                      clearable></el-input>
          </div>
          <el-table
              :data="valueDataList"
              v-loading="loading"
              size="small" :height="'calc(100vh - 360px)'"
              class="table" ref="multipleTable2" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="dataName" label="数值" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dataSort" label="排序" show-overflow-tooltip></el-table-column>
            <el-table-column
                fixed="right" min-width="100px"
                label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="addFigure(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="deleteData(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination :total="total" :page.sync="valueSearch.current" :limit.sync="valueSearch.size"
                      @pagination="getValueList"/>
        </div>
      </div>
    </div>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title2" width="400px" :close-on-click-modal="false"
               :visible.sync="visible2">
      <el-form size="small" ref="addForm" :model="addForm" :rules="addFormRules"
               @keyup.enter.native="doSubmitAdd()" @submit.native.prevent
               label-width="110px">
        <el-form-item label="数值：" prop="dataName">
          <el-input v-model.trim="addForm.dataName" maxlength="20"
                    placeholder="请输入数值(限20字)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="dataSort">
          <el-input-number v-model="addForm.dataSort" :min="1" :max="maxSort"
                           label="请输入数值"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="primary" @click="doSubmitAdd()" v-noMoreClick>确定</el-button>
        <el-button size="small" @click="visible2 = false">取消</el-button>
      </div>
    </el-dialog>
    <semantic-add ref="semanticAdd" @refresh="refreshList"></semantic-add>
  </div>
</template>

<script>

import SemanticAdd from "@/views/modules/academic/academic/semanticAdd.vue";
import XEUtils from "xe-utils";

export default {
  name: "semanticLibrary",
  components: {SemanticAdd},
  data() {
    return {
      searchForm: {
        keyword: '',
      },
      loading: false,
      dataList: [],
      dataListSelect: [],
      levelData: '',

      detailData: null,
      activeName: 'first',
      detailForm: {
        id: '',
        parentId: '',
        semanticName: '',
        semanticDescription: '',
      },
      rules: {
        semanticName: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
      },
      maxSort: '',
      valueSearch: {
        semanticId: '',
        keyword: '',
        current: 1,
        size: 20,
      },
      total: 0,
      valueDataList: [],
      loading: false,

      title2: '新增数值',
      visible2: false,
      addForm: {
        id: '',
        dataName: '',
        dataSort: 1,
        semanticId: '',
      },
      addFormRules: {
        dataName: [
          {required: true, message: '请输入数值', trigger: 'blur'}
        ],
        dataSort: [
          {required: true, message: '请输入排序', trigger: 'blur'}
        ],
      },
    }
  },

  mounted() {
    this.refreshList()
  },

  methods: {
    // 获取数据列表 current查第几页数据
    refreshList(type, clearSelect) {
      this.detailData = null
      if (clearSelect) {
        this.$refs.multipleTable.clearSelection()
      }
      this.loading = true
      this.$axios(this.api.user.configKey + 'knowledge_hierarchy').then(data => {
        if (data && data.status) {
          this.levelData = data.data
          this.$axios(this.api.academic.semanticcorpusList, {}).then(data => {
            if (data && data.status) {
              this.originalData = data.data
              this.dataList = this.handleTree(
                  data.data,
                  'id',
                  'parentId',
                  'children',
                  '0'
              )
              // 调用函数设置层级
              this.setNodeLevels(this.dataList);
              this.filterSearch();
              this.loading = false
            } else {
              this.$message.error('查询失败')
            }
          })
        }
      })
    },
    filterSearch() {
      if (this.searchForm.keyword) {
        let options = {children: 'children'}
        let searchProps = ['semanticName', 'semanticDescription']
        this.dataList = XEUtils.searchTree(this.dataList, item => searchProps.some(key => XEUtils.toValueString(item[key]).indexOf(this.searchForm.keyword) > -1), options)
        console.log(this.dataList);
      }
    },
    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.orderBy = ''
      this.refreshList(1, 1)
    },

    //表格勾选数据
    selectionChangeHandle(val) {
      this.dataListSelect = val
    },

    exportData() {
      if (this.dataList.length == 0) {
        this.$message.warning('暂无可导出的数据!')
        return
      }
      let ids = this.dataListSelect.map(item => {
        return item.id
      })
      this.exportExcel(this.api.academic.semanticcorpusExport, {
        ids,
        keyword: this.searchForm.keyword,
      }, '语义库管理', 'post')
    },

    //num 1 新增同级 2 新增子级 edit 修改 detail 详情
    addData(type, row) {
      this.$refs.semanticAdd.init(type, row)
    },

    seeDetail(row) {
      this.$axios(this.api.academic.semanticcorpusGetById + row.id, {}, 'get').then(data => {
        if (data && data.status) {
          Object.keys(this.detailForm).forEach(key => {
            this.detailForm[key] = data.data[key]
          })
          this.addForm.semanticId = row.id
          this.valueSearch.semanticId = row.id
          this.getValueList(1)
          this.detailData = row
        }
      })
      this.$axios(this.api.user.configKey + 'publish_sequence').then(data => {
        if (data && data.status) {
          this.maxSort = parseInt(data.data)
        }
      })
    },

    doSubmitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (!this.addForm.id) {
            this.$axios(this.api.academic.semanticcorpusdataSave, this.addForm, 'post').then(data => {
              if (data && data.status) {
                this.$message.success('保存成功')
                this.visible2 = false
                this.getValueList()
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            this.$axios(this.api.academic.semanticcorpusdataUpdateById, this.addForm, 'put').then(data => {
              if (data && data.status) {
                this.$message.success('修改成功')
                this.visible2 = false
                this.getValueList()
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      })
    },

    addFigure(row) {
      this.visible2 = true
      this.title2 = '新增数值'
      this.addForm.id = ''
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      })
      if (row) {
        this.title2 = '编辑数值'
        this.getFigureDetail(row.id)
      }
    },

    getFigureDetail(id) {
      this.$axios(this.api.academic.semanticcorpusdataGetById + id, {}, 'get').then(data => {
        if (data && data.status) {
          Object.keys(this.addForm).forEach(key => {
            this.addForm[key] = data.data[key]
          })
        }
      })
    },

    deleteData(row) {
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.semanticcorpusdataRemoveById + row.id, {}, 'delete').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.getValueList()
          }
        })
      })
    },

    //提交
    doSubmit() {
      this.$refs.detailForm.validate((valid) => {
        if (valid) {
          this.$axios(this.api.academic.semanticcorpusUpdateById, this.detailForm, 'put').then(data => {
            if (data && data.status) {
              this.$message.success('修改成功')
              this.refreshList()
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      });
    },

    getValueList(currtSet){
      if (currtSet == 1) {
        this.valueSearch.current = 1
      }
      this.loading = true
      this.$axios(this.api.academic.semanticcorpusdataList, this.valueSearch, 'get').then(data => {
        if (data && data.status) {
          this.loading = false
          this.valueDataList = data.data.records
          this.total = parseInt(data.data.total)
          if (this.valueDataList.length == 0 && this.valueSearch.current > 1) {
            this.valueSearch.current--
            this.refreshList()
          }
        }
      })
    },

    //删除
    deleteColumn(row) {
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.semanticcorpusRemoveById + row.id, {}, 'delete').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    setNodeLevels(list, level = 1) {
      let that = this;
      list.forEach(function (node) {
        // 为当前节点设置层级属性
        node.level = level;
        if (node.level >= that.levelData) {
          that.$set(node, 'disabledBotm', true)
        }
        // 遍历当前节点的子节点，并递归调用setNodeLevels函数
        if (node.children && node.children.length > 0) {
          that.setNodeLevels(node.children, level + 1);
        }
      })
    },

    // 复选框点击事件
    selectFun(selection, row) {
      this.setRowIsSelect(row)
    },

    // 复选框点击事件
    setRowIsSelect(row) {
      // 为空字符串则对应行半选态，点击则应该变为全选，则为true
      if (row.isSelect === '') {
        this.$refs.multipleTable.toggleRowSelection(row, true)
      }
      row.isSelect = !row.isSelect
      const _this = this
      // 判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选

      // 1、只是父级 2、既是子集，又是父级 3、只是子级
      const levelStatus = getCurrentLevel(row)

      if (levelStatus === 1) {
        // 操作的是父级，则所有子集同步父级状态
        selectAllChildren(row.children)
      } else if (levelStatus === 2) {
        selectAllChildren(row.children)
        operateLastLevel(row)
      } else if (levelStatus === 3) {
        operateLastLevel(row)
      }

      // 判断当前操作行的层级状态
      function getCurrentLevel(row) {
        // 1、只是父级 2、既是子集，又是父级 3、只是子级
        if (row.parentId === undefined) {
          return 1
        } else if (row.parentId && !(row.children && row.children.length)) {
          return 3
        } else {
          return 2
        }
      }

      // 递归处理children子级数据的isSelect状态以及对选框状态
      function selectAllChildren(children) {
        children && children.length && children.forEach((item) => {
          item.isSelect = row.isSelect
          _this.toggleRowSelection(item, row.isSelect)
          if (item.children && item.children.length) {
            selectAllChildren(item.children)
          }
        })
      }

      // 子级向上操作父级状态
      function operateLastLevel(row) {
        // 操作的是子节点,则
        // 1、获取父节点
        // 2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
        const item = getExplicitNode(_this.tableData, row.parentId)
        if (!item) {
          return
        }
        const selectStatusArr = getSelectStatus([], item.children)

        // 判断所有子集选中态，都为true则父级也选中，都为false则不选中，否则为半选
        const allSelected = selectStatusArr.every(selectItem => selectItem === true)
        const allUnselected = selectStatusArr.every(selectItem => selectItem === false)
        if (allSelected) {
          item.isSelect = true
          _this.toggleRowSelection(item, true)
        } else if (allUnselected) {
          item.isSelect = false
          _this.toggleRowSelection(item, false)
        } else {
          item.isSelect = ''
        }
        // 如果当前节点的parentId存在，则还有父级，继续递归往上一层操作
        if (item.parentId !== undefined) {
          operateLastLevel(item)
        }
      }

      // 递归获取所有子级的选中状态数组
      function getSelectStatus(selectStatusArr, children) {
        if (!children || !children.length) {
          return selectStatusArr
        }
        children.forEach((child) => {
          selectStatusArr.push(child.isSelect)
          if (child.children && child.children.length) {
            getSelectStatus(selectStatusArr, child.children)
          }
        })
        return selectStatusArr
      }

      // 获取明确父级的节点
      function getExplicitNode(tableData, parentId) {
        let result = null

        function findNode(data) {
          if (!data || data.length == 0) return
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === parentId) {
              result = data[i]
              break
            }
            if (data[i].children && data[i].children.length) {
              findNode(data[i].children)
            }
          }
        }

        findNode(tableData)
        return result
      }
    },

    // 表格全选事件
    selectAllFun(selection) {
      const firstLevelStatus = this.dataList.map(item => item.isSelect)
      // 判断一级是否是全选.如果一级产品全为true，则设置为取消全选，否则全选
      const isAllSelect = firstLevelStatus.every(status => status)
      // 设置所以一级和二级为选中状态
      this.dataList.forEach((item) => {
        item.isSelect = isAllSelect
        this.toggleRowSelection(item, !isAllSelect)
        this.selectFun(selection, item)
      })
    },
    // 设置当前行的选中态
    toggleRowSelection(row, flag) {
      if (row) {
        this.$nextTick(() => {
          this.$refs.multipleTable &&
          this.$refs.multipleTable.toggleRowSelection(row, flag)
        })
      }
    },
    // 表格行样式 当当前行的状态为不明确状态时，添加样式，使其复选框为不明确状态样式
    getRowClassName({row}) {
      if (row.isSelect === '') {
        return 'indeterminate'
      }
    },
    // 表格标题样式 当一级目录有为不明确状态时，添加样式，使其全选复选框为不明确状态样式
    getHeaderRowClassName({row}) {
      const isIndeterminate = this.dataList.some(item => item.isSelect === '')
      if (isIndeterminate) {
        return 'indeterminate'
      }
      return ''
    },
  }
}
</script>

<style lang="scss" scoped>
.contentHeigh {
  height: 100%;
  background: aliceblue;
}

.dataBox1 {
  width: 60%;
  height: 100%;
}

.dataBox2 {
  width: 100%;
  height: 100%;
}

.dataDetail {
  width: calc(40% - 10px);
  height: 100%;
  background: #FFFFFF;
  border-radius: 5px;
  overflow-y: auto;
  margin: 0 5px;
  padding: 10px;

  .dataDetail-tir {
    padding-bottom: 5px;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .closeD {
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
